import { render, staticRenderFns } from "./StudentMarksByMonths.vue?vue&type=template&id=cf8c0ef8"
import script from "./StudentMarksByMonths.vue?vue&type=script&lang=js"
export * from "./StudentMarksByMonths.vue?vue&type=script&lang=js"
import style0 from "./StudentMarksByMonths.vue?vue&type=style&index=0&id=cf8c0ef8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports